import { startSlider } from './config.js';

export const initAboutCompanyMission = () => {
    const mobile = window.matchMedia('(max-width: 600px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-mission-section]').forEach((section) => {
        const slider = section.querySelector('[data-mission-slider]');
        const scrollbar = section.querySelector('[data-mission-scrollbar]');
        const panel = section.querySelector('.mission__panel');
        const container = section.querySelector('.container');
        const wrapper = section.closest('.about-mission-wrapper');

        if (!slider || !scrollbar || !panel || !container) {
            return;
        }

        let distance = 0;
        let stickyTop = 0;
        let scrollStart = 0;
        let frame = 0;

        const updateProgress = () => {
            frame = 0;
            const swiper = slider.swiper;

            if (!swiper || !distance) {
                return;
            }

            const progress = Math.max(0, Math.min(1,
                (scrollStart - section.getBoundingClientRect().top) / distance
            ));
            swiper.setProgress(progress, 0);
        };

        const requestProgress = () => {
            if (!frame) {
                frame = window.requestAnimationFrame(updateProgress);
            }
        };

        const measure = () => {
            const swiper = slider.swiper;

            if (!swiper) {
                return;
            }

            // Clear the pin before measuring the natural panel at this breakpoint.
            section.classList.remove('mission--scroll-driven');
            section.style.removeProperty('--mission-scroll-height');
            swiper.update();
            distance = reducedMotion.matches ? 0 : Math.abs(swiper.maxTranslate());

            if (distance > 0) {
                const containerHeight = container.offsetHeight;
                const viewportSpace = window.innerHeight - containerHeight;
                // Use the fully visible entry into a tall viewport for horizontal travel.
                scrollStart = viewportSpace;
                stickyTop = Math.min(0, viewportSpace);
                const pinDistance = Math.max(0, distance - Math.max(0, viewportSpace));
                section.style.setProperty('--mission-sticky-top', `${stickyTop}px`);
                section.style.setProperty('--mission-scroll-height', `${containerHeight + pinDistance}px`);
                section.classList.add('mission--scroll-driven');
            }

            if (wrapper) {
                const siblingsHeight = Array.from(wrapper.children)
                    .filter((child) => child !== section)
                    .reduce((height, child) => height + child.offsetHeight, 0);
                // A short outer sticky group would stop the remaining horizontal travel.
                wrapper.classList.toggle('about-mission-wrapper--free',
                    distance > 0 && window.innerHeight > container.offsetHeight + siblingsHeight
                );
            }

            updateProgress();
        };

        const syncSlider = () => {
            slider.swiper?.destroy(true, true);
            distance = 0;
            section.classList.remove('mission--scroll-driven');
            section.style.removeProperty('--mission-scroll-height');
            section.style.removeProperty('--mission-sticky-top');

            wrapper?.classList.remove('about-mission-wrapper--free');

            if (mobile.matches) {
                slider.removeAttribute('tabindex');
                return;
            }

            slider.setAttribute('tabindex', '0');
            startSlider(slider, {
                slidesPerView: 2,
                spaceBetween: 150,
                breakpoints: {
                    1025: { slidesPerView: 3, spaceBetween: 200 },
                },
                speed: 0,
                allowTouchMove: reducedMotion.matches,
                scrollbar: { el: scrollbar, draggable: reducedMotion.matches, hide: false },
            });
            measure();
        };

        slider.addEventListener('keydown', (event) => {
            const swiper = slider.swiper;

            if (!swiper || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
                return;
            }

            event.preventDefault();
            const next = (event.key === 'ArrowRight') !== swiper.rtl;

            if (!distance) {
                if (event.key === 'Home') {
                    swiper.slideTo(0);
                } else if (event.key === 'End') {
                    swiper.slideTo(swiper.slides.length - 1);
                } else if (next) {
                    swiper.slideNext();
                } else {
                    swiper.slidePrev();
                }
                return;
            }

            const step = swiper.slidesSizesGrid[0] + Number(swiper.params.spaceBetween);
            const current = Math.max(0, Math.min(distance, scrollStart - section.getBoundingClientRect().top));
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? distance
                : Math.max(0, Math.min(distance, current + (next ? step : -step)));
            window.scrollTo({ top: window.scrollY + section.getBoundingClientRect().top - scrollStart + target });
        });

        new ResizeObserver(measure).observe(panel);
        window.addEventListener('scroll', requestProgress, { passive: true });
        window.addEventListener('resize', measure);
        window.addEventListener('load', measure);
        mobile.addEventListener('change', syncSlider);
        reducedMotion.addEventListener('change', syncSlider);
        document.fonts?.ready.then(measure);
        syncSlider();
    });
};
